export default __webpack_public_path__ + "static/media/generalLight.9276e994.svg";